'use strict';

import Vue from 'vue';
const DownloadProgressBar = new Vue();

export default {
    DownloadProgressBar
};
